import { NAME as APP_NAME } from '../constants';

export const NAME = `${APP_NAME}/DOCS`;

export const LISTING_ENDPOINT = filters => `${OPERATIONS_EDGE}/api/filecabinet/${filters.pid}`;

export const REDUCER_NAME = 'driverDocs';

export const STATUS_MAP = {
  UNAPPROVED: 'UNAPPROVED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
};
